module.exports = __webpack_public_path__ + "static/media/loseManualSFX.df2beab2.mp3";